import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { getData } from "features/dinamic";


interface ActividadExtraState {
    status: string;
    error: string;
    actividadExtraList: any[],
    actividadExtraListActive: any[],
    actividadExtra: {
        idActividadExtra: number | null;
        nombre: string | null;
    }

}

const initialState: ActividadExtraState = {
    status: 'idle',
    error: '',
    actividadExtraList: [],
    actividadExtraListActive: [],
    actividadExtra: {
        idActividadExtra: null,
        nombre: null
    }
}

export const fetchActividadExtra = createAsyncThunk('fetchActividadExtra', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 53;
    const { result, message, data } = await getData({ idsp }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const fetchActividadExtraActive = createAsyncThunk('fetchActividadExtraActive', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 54;
    const { result, message, data } = await getData({ idsp }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});


export const actividadExtraSlice = createSlice({
    name: 'actividadExtra',
    initialState,
    reducers: {
        setActividadExtraList: (state, action) => {
            state.actividadExtraList = action.payload;
        },
        setActividadExtraListActive: (state, action) => {
            state.actividadExtraListActive = action.payload;
        },
        setActividadExtra: (state, action) => {
            state.actividadExtra = !action.payload ? initialState.actividadExtra : action.payload;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(fetchActividadExtra.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchActividadExtra.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.actividadExtraList = data ? data : [];

            })
            .addCase(fetchActividadExtra.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
            .addCase(fetchActividadExtraActive.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchActividadExtraActive.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.actividadExtraListActive = data ? data : [];

            })
            .addCase(fetchActividadExtraActive.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
    }
})

export const selectActividadExtraList = (state: RootState) => state.actividadExtra.actividadExtraList;
export const selectActividadExtraListActive = (state: RootState) => state.actividadExtra.actividadExtraListActive;
export const selectActividadExtra = (state: RootState) => state.actividadExtra.actividadExtra;

export const { setActividadExtraList, setActividadExtraListActive, setActividadExtra } = actividadExtraSlice.actions;

export default actividadExtraSlice.reducer;



